module.exports = __webpack_public_path__ + "img/natura.2ade9021.png";